/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  TextField,
  Box,
  createFilterOptions,
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Popper,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import commonService from '../../../services/commonService';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';

const filter = createFilterOptions();

const BidGroup = (props) => {
  const { setSelectedBidGroup, selectedBidGroup, showTopHelperText } = props;
  const [bidGroups, setBidGroup] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [newKey, setNewKey] = useState('');
  const [anchor, setAnchor] = useState(null);

  const onClose = () => {
    setOpenModal(false);
    setSelectedBidGroup(null);
  };

  const getBidGroup = (cb) => {
    commonService.getBidRequestGroup().then((response) => {
      if (response) {
        setBidGroup(response);
        if (cb) {
          cb(response);
        }
      }
    });
  };

  const addBidGroup = (model) => {
    commonService.addBidRequestGroup(model).then((response) => {
      if (response) {
        onClose();
        setSelectedBidGroup(response);
        const selectBidGroup = () => {
          setSelectedBidGroup({ name: model.name });
        };
        getBidGroup(selectBidGroup);
        toast.success('İhale grubu eklendi');
      }
    });
  };

  useEffect(() => {
    getBidGroup();
  }, []);

  return (
    <>
      <Popper
        open={anchor}
        anchorEl={anchor}
      >
        <Box sx={{ border: 1, p: 1, mt: 2, bgcolor: 'background.paper' }}>
          <Typography>İhaleleri bir proje yada alım grubu altında toplamak için grup ismi atayabilirsiniz</Typography>
        </Box>
      </Popper>
      <Autocomplete
        freeSolo
        name="bidGroup"
        value={selectedBidGroup}
        className="tp-bg-bid-group"
        onChange={(event, newValue,) => {
          if (typeof newValue === 'string') {
            const bidGroup = bidGroups.find((f) => f.name === newValue);
            if (bidGroup) {
              setSelectedBidGroup(bidGroup);
            } else {
              setNewKey(newValue);
              setOpenModal(true);
            }
          } else if (newValue && newValue.inputValue) {
            setNewKey(newValue.inputValue);
            setOpenModal(true);
          } else {
            setSelectedBidGroup({
              ...newValue,
            });
          }
        }}
        options={bidGroups.map((group) => group.name)}
        disableClearable
        renderInput={(params) => (
          <Box
            sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
            className="tp-bid-group__icon-wrapper mt-20 mb-10"
          >
            {
              !selectedBidGroup && showTopHelperText && (
                <FormHelperText sx={{ position: 'absolute', top: -25, left: 15 }}>İsteğe bağlı</FormHelperText>
              )
            }
            <TextField
              {...params}
              label="İhale Grubu"
              variant="outlined"
              sx={{
                background: '#e8f4fd',
                borderRadius: (theme) => `${theme.shape.borderRadius}px`,
              }}
            />
            <Box
              onMouseEnter={(e) => {
                setAnchor(e.currentTarget);
              }}
              onMouseLeave={() => {
                setAnchor(null);
              }}
            >
              <LiveHelpIcon />
            </Box>
          </Box>
        )}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.title;
          }
          // Regular option
          return option.name || '';
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          // eslint-disable-next-line no-useless-escape
          if (params.inputValue !== '' && !params.inputValue.includes('\"')) {
            filtered.push({
              inputValue: params.inputValue,
              title: `İhale Grubu Oluştur "${params.inputValue}"`,
            });
          }

          return filtered;
        }}
      />
      <Dialog
        open={openModal}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
      >
        <Formik
          initialValues={
            {
              name: newKey,
            }
          }
          validationSchema={Yup.object().shape({
            name: Yup.string().required('zorunlu'),
          })}
          onSubmit={(values) => {
            addBidGroup(values);
          }}
        >
          {
            ({ values, errors, touched, handleSubmit, handleChange }) => (
              <form onSubmit={(val) => handleSubmit(val)}>
                <DialogTitle>Yeni bir ihale grubu ekle</DialogTitle>
                <DialogContent>
                  <Box sx={{
                    m: 1,
                    width: 240
                  }}
                  >
                    <TextField
                      autoFocus
                      margin="dense"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      label="title"
                      type="text"
                      error={Boolean(touched.name && errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={onClose}
                    color="primary"
                  >
                    İptal
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                  >
                    Ekle
                  </Button>
                </DialogActions>
              </form>
            )
          }
        </Formik>
      </Dialog>
    </>
  );
};

export default BidGroup;

BidGroup.propTypes = {
  setSelectedBidGroup: PropTypes.func.isRequired,
  selectedBidGroup: PropTypes.any,
  showTopHelperText: PropTypes.bool,
};
